export enum TitleSize {
  H1 = "H1",
  H2 = "H2",
  H3 = "H3",
  H4 = "H4",
  H5 = "H5",
  H6 = "H6",
}

export enum TextAlignment {
  Left = "LEFT",
  Center = "CENTER",
  Right = "RIGHT",
  Justify = "JUSTIFY",
}

export enum ColumnAlignment {
  Left = "LEFT",
  Center = "CENTER",
  Right = "RIGHT",
  Stretch = "STRETCH",
}

export enum FlexPosition {
  Left = "LEFT",
  Center = "CENTER",
  Right = "RIGHT",
  Stretch = "STRETCH",
  Top = "TOP",
  Middle = "MIDDLE",
  Bottom = "BOTTOM",
  Around = "AROUND",
  Between = "BETWEEN",
  Evenly = "EVENLY",
  RowReverse = "ROW_REVERSE",
}
